module.exports = __webpack_public_path__ + "img/Group 1094one.4a3534cc.svg";